import React, { useCallback } from 'react'
import createUsePollingWithCache from 'hooks/createUsePollingWithCache'
import { getData as apiGetData } from 'api/Api'
import styled from 'styled-components'
import KanBoIcon from 'components/KanBoIcon'
import { FormattedMessage } from 'components/Intl'

const CardIcon = styled(KanBoIcon)`
  margin-right: 0.25em;
  font-size: 16px;
`

type CardNamesData = {
  Cards: {
    Id: number
    Name: string
  }[]
}

const usePollingWithCache = createUsePollingWithCache<string | null>({
  getData: (ids, setData) => {
    apiGetData('CardNames', { cardIds: ids }).then((data: CardNamesData) => {
      ids.forEach(id => setData(id, (data.Cards.find(Card => Card.Id === Number(id)) || { Name: null }).Name))  
    })
  }
})

type RenderData = {
  name: string | null | undefined;
  noAccess: boolean;
  isLoaded: boolean;
  isLoading: boolean;
  render: () => React.ReactElement
}

type Props = {
  children?: (data: RenderData) => React.ReactElement

  id: number
}

const CardName: React.FC<Props> = ({
  children,

  id,
}) => {
  const name = usePollingWithCache(String(id))

  const noAccess = name === null

  const isLoaded = name !== undefined

  const isLoading = name === undefined

  const render = useCallback(() => {
    return (
      <span
        className={noAccess ? 'text-danger' : undefined}
      >
        {isLoaded ? (
          <>
            <CardIcon
              name='kanbo-16-card'
            />
            {
              noAccess
                ? <FormattedMessage id='LINK_KANBO_NO_ACCESS' />
                : name
            }
          </>
        ) : (
          <KanBoIcon spin name='kanbo-16-loading' />
        )}
      </span>
    )
  }, [name, isLoaded, noAccess])

  if (children) {
    return children({
      name,
      noAccess,
      isLoaded,
      isLoading,
      render,
    })
  }

  return render()
}

export default CardName
